import { ROUTES } from '../../config/routing/routes'

export default function getRouteData (routeType) {
  return ROUTES[routeType]
}



// WEBPACK FOOTER //
// ./src/utils/routing/getRouteData.js